// index.cgi
window.ht_tab_items = new Array(
    "tab_a",
    "tab_b",
    "tab_c",
    "tab_d",
    "tab_e",
    "tab_f",
    "tab_g"
);
window.ht_ShowTab = function (a_id) {
    ht__hideAll();
    var view = a_id + "_view";
    var tab = a_id + "_tab";
    var tvw = document.getElementById(view);
    if (tvw) tvw.style.display = "block";
    var ttab = document.getElementById(tab);
    if (ttab) ttab.className = "tab_selected";
    window.scrollBy(0, 0);
    return false;
};

window.ht__hideAll = function () {
    for (i = 0; i < ht_tab_items.length; i++) {
        var tab_item = ht_tab_items[i];
        var tvw = document.getElementById(tab_item + "_view");
        if (tvw) tvw.style.display = "none";
        var ttab = document.getElementById(tab_item + "_tab");
        if (ttab) ttab.className = "tab_not_selected";
    }
};

// archives.cgi
window.last_sort = 0;
window.sortRow = function (th, idx) {
    var sec = th.parentNode.parentNode.parentNode;
    var x = new Array(),
        rows = sec.rows,
        N = rows.length - 1;
    var marker = document.createElement("tbody");
    for (var i = 0; i < N; ++i) {
        if (rows[i + 1].cells[idx].firstChild === null) {
            content = "";
        } else {
            content = rows[i + 1].cells[idx].firstChild.nodeValue;
        }
        x[i] = Object(content);
        x[i].row = rows[i + 1];
    }
    x.sort();
    if (last_sort == idx) {
        x.reverse();
        idx = 2 - idx;
    }
    sec.parentNode.replaceChild(marker, sec);
    for (var i = 0; i < N; ++i) sec.appendChild(x[i].row);
    marker.parentNode.replaceChild(sec, marker);
    last_sort = idx;
};

window.textDisp = function (id1, id2) {
    if (!document.getElementById) return;
    var obj = document.getElementById(id1);
    switch (obj.className) {
        case "textBody1":
            obj.className = "textBody2";
            for (i = 0; document.getElementById(id2 + i); i++) {
                var obj2 = document.getElementById(id2 + i);
                obj2.style.display = "block";
            }
            break;
        case "textBody2":
            obj.className = "textBody3";
            break;
        default:
            obj.className = "textBody1";
            for (i = 0; document.getElementById(id2 + i); i++) {
                var obj2 = document.getElementById(id2 + i);
                obj2.style.display = "none";
            }
    }
};

window.contentsFilter = function (th) {
    var contentsInput = document.getElementById("contents");
    var allContentsRow = document.querySelectorAll(".content-row");

    allContentsRow.forEach((elem) => {
        elem.style.display = "";
    });
    filterQuery = contentsInput.value.toLowerCase();
    allContentsRow.forEach((elem) => {
        var content = elem.childNodes[5].innerText;
        if (content.toLowerCase().indexOf(filterQuery) === -1) {
            elem.style.display = "none";
        }
    });
};

// search/index.cgi
window.fc = function () {
    document.form1.word.focus();
};

window.showhide1 = function (id) {
    if (!document.getElementById) return;
    var obj = document.getElementById(id);
    if (obj.style.display == "block") {
        obj.style.display = "none";
    } else {
        obj.style.display = "block";
    }
};

window.checkInput = function (form) {
    if (document.form1.word.value == "") {
        alert("Plese input keyword.");
        return false;
    }
    count = 0;
    for (i = 0; i < document.form1["datatxt[]"].length; i++) {
        if (document.form1["datatxt[]"][i].checked) {
            count++;
        }
    }
    if (document.form1.tSelect.checked && count == 0) {
        alert("Please select files or remove the option.");
        return false;
    }
};

window.setTF = function (cOBJ) {
    for (i = 0; i < document.form1["datatxt[]"].length; i++) {
        document.form1["datatxt[]"][i].disabled = !cOBJ.checked;
    }
};

window.showhide2 = function (id) {
    if (!document.form1.tSelect.checked) {
        document.getElementById(id).style.color = "#9CA3AF";
        document.getElementById(id).style.backgroundColor = "#F3F4F6";
    } else {
        document.getElementById(id).style.color = "black";
        document.getElementById(id).style.backgroundColor = "BlanchedAlmond";
    }
};

// archives用
window.removeEnter = function () {
    var contents = document.getElementById("contents");
    contents.addEventListener("keydown", function (e) {
        var keyCode = e.code;
        if (keyCode && keyCode === "Enter") {
            e.preventDefault();
            return false;
        } else {
            return true;
        }
    });
};
